import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PathService} from '../../login/services/path.service';
import {Observable} from 'rxjs';
import {CountryDtoModel} from '../models/country.dto.model';

@Injectable({
    providedIn: 'root'
})
export class CountryService {

    private baseUrl = '';

    constructor(protected http: HttpClient, private pathService: PathService) {
        this.baseUrl = `${pathService.hostServerBackOffice}/countries`;
    }

    public findAllCountries(): Observable<CountryDtoModel[]> {
        return this.http.get<CountryDtoModel[]>(`${this.baseUrl}/all`);
    }
}
